<template lang="pug">
div
  span.table-date.table-date_additional.table-date_nowrap(v-for="(course, index) in item.confirmedCourses" :key="index") 
    template(v-if="index < 2")
      | {{ course.dateAndName }}
      template(v-if="!(index === item.confirmedCourses.length - 1)") , 
  template(v-if="item.confirmedCourses.length > 2")
    v-menu(max-width="185px" top)
      template(v-slot:activator="{on}") 
        div.link(v-on="on").table-date__show-more show more
      v-list
        v-list-item(v-for="(coursers, index) in item.confirmedCourses" :key="index").min-auto
          v-list-item-title.table-date.table-date_additional
            | {{ coursers.dateAndName }}
            template(v-if="!(index === item.confirmedCourses.length - 1)") , 
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.min-auto {
  min-height: auto;
}
.table-date {
  font-size: 10px;
  display: block;
  &__show-more {
    font-size: 10px;
  }
  &_nowrap {
    white-space: nowrap;
    overflow: hidden;
    word-break: break-all;
    text-overflow: ellipsis;
  }
  &_main {
    font-weight: bold;
  }
  &_additional {
    line-height: 1.3;
    color: $label-color;
    font-weight: 500;
  }
}

</style>